import type { _RouteLocationBase } from 'vue-router'

const PartnerBudgetView = async () => import('@/views/report/PartnerBudgetView.vue')

export default [
  {
    path: '/report/budget/:code',
    name: 'report_budget_overview',
    component: PartnerBudgetView,
    props: (route: _RouteLocationBase) => {
      return { code: route.params.code }
    }
  }
]
